module.exports = {
	"A_BdE_homologated_company": "Societat Homologada pel Banco de España",
	"About_BARNATASA": "About BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA és una Societat de Taxació Homologada pel Banco de España, inscrita en el Registre Oficial d'Entitats de Taxació amb el nº 4.470 i data d'inscripció 26 de juny de 1.995",
	"About_text_02": "La societat està formada per un grup d'arquitectes, enginyers i especialistes en el camp de la valoració i taxació immobiliàries i un ampli coneixemnt del sector, amb més de 30 anys de trajectòria",
	"About_us": "Sobre nosaltres",
	"acc_Budget": "s/ Pressupost",
	"acc_appraisal_date": "s/ data de taxació",
	"Actions": "Accions",
	"Ad": "Anunci",
	"Ad_address": "Adreça tal i com apareix a l'anunci",
	"Ad_code": "Codi de l'anunci",
	"Ad_data_type": "Tipus de dades",
	"Ad_database_query": "Consulta d'anuncis a la base de dades",
	"Ad_date": "Data de l'anunci",
	"Ad_type": "Tipus d'anunci",
	"Ads": "Anuncis",
	"Adaptability": "Adaptabilitat",
	"Add_address": "Afegir adreça",
	"Add_appraisal": "Afegir taxació",
	"Add_appraisal_file": "Afegir expedient de taxació",
	"Add_appraisal_report": "Afegir informe de taxació",
	"Add_contact": "Afegir contacte",
	"Add_entity": "Afegir entitat",
	"Add_email": "Afegir e-mail",
	"Add_market_study": "Afegir estudi de mercat",
	"Add_real_estate": "Afegir immoble",
	"Add_room": "Afegir estança",
	"Add_telephone_number": "Afegir nº de telèfon",
	"Add_to_comparables_list": "Afegir a la llista de comparables",
	"Address": "Adreça",
	"Address_description": "Descripció de l'adreça",
	"Addresses": "Adreces",
	"Adjusted_Comparison_Method": "Mètode de Comparació Ajustat",
	"Adopted_age": "Antiguitat considerada",
	"Adopted_area": "Superfície adoptada",
	"Adopted_building_market_value": "Valor de mercat de l'edificació adoptat",
	"Adopted_material_execution_cost": "Cost d'execució material adoptat",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Cost d'execució material adoptat depreciat per antiguitat",
	"Adopted_value": "Valor adoptat",
	"Age": "Antiguitat",
	"Agravation_or_improvement_coeficient": "Coeficient d'agreujament o millora",
	"Air_conditioning": "Aire acondicionat",
	"and": "i",
	"and_limit_date": "i la data límit",
	"annexes": "annexes",
	"Annexes": "Annexes",
	"Addressing_title": "Títol de tractament",
	"Advertisements_between_starting_date": "Anuncis entre la data d'inici",
	"appraisal": "taxació",
	"Appraisal": "Taxació",
	"appraisal_company": "societat de taxació",
	"appraisal_file": "expedient de taxació",
	"Appraisal_date": "Data de taxació",
	"Appraisal_description": "Descripció de la taxació",
	"Appraisal_file": "Expedient de taxació",
	"Appraisal_files": "Expedients de taxació",
	"Appraisal_file_description": "Descripció de l'expedient de taxació",
	"Appraisal_files_index": "Índex d'expedients de taxació",
	"appraisal_report": "informe de taxació",
	"Appraisal_report": "Informe de taxació",
	"Appraisal_report_description": "Descripció de l'informe de taxació",
	"Appraisal_reports": "Informes de taxació",
	"Appraisal_petitioner": "Sol·licitant de taxació",
	"Appraisal_petitioners": "Sol·licitants de taxació",
	"Appraisal_purpose": "Finalitat de la taxació",
	"Appraisal_Requests": "Sol·licituds de taxació",
	"Appraisal_total_value_determination": "Determinació del valor total de taxació",
	"Appraisal_type": "Tipus de taxació",
	"Appraisal_value": "Valor de taxació",
	"Appraisals": "Taxacions",
	"Appraisals_and_valuations": "Taxacions i valoracions",
	"Appraisals_Index": "Índex de Taxacions",
	"Appraisals_for_all_purposes": "Taxacions per a totes les finalitats",
	"Appraisals_of_the_Real_Estate": "Taxacions de l'Immoble",
	"Appraised": "Taxat",
	"Appraised_real_estates": "Immobles taxats",
	"Appraised_real_estates_in_this_report": "Immobles taxats en aquest informe",
	"Appraised_real_estate": "Immoble taxat",
	"Appraiser": "Taxador",
	"Approximate_property_area": "Superfície aproximada de l'immoble",
	"Are_you_sure_q": "N'estàs segur?",
	"Area": "Superfície",
	"Areas": "Superfícies",
	"areas": "superfícies",
	"As_new_construction_cost": "Cost de construcció a nou",
	"Assets_value_update": "Actualització del valor de patrimonis",
	"Assurance": "Garantia",
	"at": "a",
	"Auditors": "Auditors",
	"average": "mitjana",
	"Average": "Mitjana",
	"Back_home": "Tornar a l'inici",
	"Back_to_safety": "Tornar a un lloc segur",
	"Bare_ownership": "Nua propietat",
	"Bare_ownership_value": "Valor de la nua propietat",
	"Barnatasa_cover_short_description": "Societat Especialitzada en Valoracions i Taxacions",
	"Barnatasa_header": "BARNA-TASA, S.A. Societat inscrita al Registre Oficial d'Entitats de Taxació amb el número 4.470. Data d'inscripció a Banco de España: 26/06/1.995",
	"Barnatasa_footer": "Fi de pàgina. Dors no utilitzable. Qualsevol anotació en el mateix és nul·la i sense cap efecte.",
	"Barnatasa_header_portrait": "Societat inscrita al Registre Oficial d'Entitats de Taxació amb el nº 4.460. Data d'inscripció a Banco de España 26/06/1995. Reg. Merc. Barcelona, Foli 12, Volum 28.173, Full B-132.666, NIF A-60840543",
	"Bathrooms": "Banys",
	"Bathrooms_number": "nº de Banys",
	"BdE_code": "codi BdE",
	"Bedrooms": "Dormitoris",
	"Bedrooms_number": "nº de Dormitoris",
	"Block": "Bloc",
	"Building_surveys": "Aixecaments de plànols",
	"Budget_request": "Sol·licitud de pressupost",
	"Builders_general_expenses_percentage": "Percentatge despeses generals del constructor",
	"Builders_general_expenses": "Despeses generals del constructor",
	"Builders_expenses_and_benefit_percentage": "Percentatge de Despeses + Benefici del constructor",
	"Builders_expenses_and_benefit": "Despeses + Benefici del constructor",
	"Builders_industrial_benefit_percentage": "Percentatge del benefici industrial tipus del constructor",
	"Builders_industrial_benefit": "Benefici industrial del constructor",
	"Building_market_value": "Valor de mercat de l'edificació",
	"real_estate_under_construction": "immoble en construcció",
	"Buildings": "Edificis",
	"Buildings_useful_life": "Vida útil de l'edifici",
	"Built_area": "Superfície construïda",
	"by": "per",
	"By": "Per",
	"Cadastral_area": "Superfície Cadastral",
	"Cadastral_data": "Dades cadastrals",
	"Cadastral_data_check": "Comprovació Cadastre",
	"Cadastral_List": "Llistat del Cadastre",
	"Cadastral_Map": "Mapa del Cadastre",
	"Cadastral_reference": "Referència cadastral",
	"Cadastral_Reference_less_20_positions_error_text": "La Referència Cadastral té menys de 20 posicions",
	"Calculate_values": "Calcular valors",
	"Calendar": "Calendari",
	"Cancel": "Cancel·lar",
	"Capture_date": "Data de captura",
	"Catalan": "Català",
	"Census_section": "Secció censal",
	"Census_section_code": "Codi de secció censal",
	"certificates": "certificats",
	"cession": "cessió",
	"Cession": "Cessió",
	"Cession_contract_period_years": "Duració del contracte (anys)",
	"Cession_contract_remaining_years": "Anys restants de contracte",
	"Cession_contract_start_date": "Data d'inici del contracte",
	"Cession_gross_monthly_income": "Renda bruta mensual actual",
	"Cession_gross_yearly_income": "Renda bruta anual actual",
	"Cession_gross_monthly_income_by_contract": "Renda bruta mensual de contracte",
	"Cession_gross_yearly_income_by_contract": "Renda bruta anual de contracte",
	"Cession_net_yearly_income": "Renda neta anual",
	"Clients_text_01": "BARNA-TASA, S.A. disposa d'una àmplia cartera de clients i treballa amb tot tipus de clients de l'àmbit privat i públic. A destacar",
	"Clients_text_02": "BARNA-TASA S.A. ofereix una àmplia gama de serveis destinats a ajudar en la presa de decisions relatives a la valoració i comprovació de l'estat d'immobles i altres béns",
	"Clients_text_03": "L'objectiu de BARNA-TASA S.A. és recolzar als clients dels millors despatxos d'advocats i auditors nacionals i internacionals, en aquelles operacions que requereixin una valoració immobiliaria. Des d'una valoració per a un procés d'expropiació, fins a les valoracions necessàries en operacions de fusió i adquisició, assessorament en desinversió d'actius i reestructuracions, abarcant tots els sectors",
	"Clients_text_04": "Un entorn empresarial com l'actual genera a les empreses la necessitat d'emprendre projectes complexos i, alhora, decisius en el seu dia a dia. Coneixedora d'aquesta circumstància, BARNA-TAXA S.A. posa la seva experiència, professionalitat i coneixement del mercat, a disposició de petites-grans empreses i entitats financeres en un ampli ventall de serveis, garantint un tracte personalitzat i professional",
	"closed": "tancat",
	"Changes_will_be_lost_p_continue_q": "Es perdran els canvis. Continuar?",
	"Checks": "Comprovacions",
	"Checks_performed": "Comprovacions realitzades",
	"Code": "Codi",
	"Commercial_premises": "Locals comercials",
	"Commission": "Encàrrec",
	"Commitment": "Compromís",
	"Company_code": "Codi de Societat",
	"Company_or_business_name": "Empresa o raó social",
	"Comparable_database_query": "Consulta de comparables a la base de dades",
	"Comparable_type": "Tipus de comparable",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Mètode de Comparació",
	"Confidentiality": "Confidencialitat",
	"Confirm_Password": "Confirmar Contrassenya",
	"Conservation": "Conservació",
	"Conservation_status": "Estat de conservació",
	"Constant_income_with_CPI_update_clause": "Renda constant amb clàusula d'actualització de l'IPC",
	"construction": "construcció",
	"Construction": "Construcció",
	"Construction_cost": "Cost de construcció",
	"Construction_cost_by_contract": "Cost de construcció per contracta",
	"Construction_cost_and_development_expenses": "Cost de construcció i despeses de promoció",
	"Construction_costs": "Costos de construcció",
	"Construction_progress_percentage": "Percentatge de construcció realitzada",
	"Construction_replacement_cost": "Cost de reposició de la construcció",
	"Construction_value": "Valor de la construcció",
	"construction_year": "any de construcció",
	"Construction_year": "Any de construcció",
	"Contact": "Contacte",
	"Contact_data": "Dades de contacte",
	"Contact_Data": "Dades del Contacte",
	"Contact_file": "Fitxa del contacte",
	"Contact_name": "Nom del contacte",
	"Contact_telephone": "Telèfon de contacte",
	"Contacts": "Contactes",
	"Contacts_Index": "Índex de Contactes",
	"contained_in_this_file": "continguts en aquest expedient",
	"contained_in_this_file_f": "contingudes en aquest expedient",
	"Continue_q": "Continuar?",
	"Contracts_foreseeable_remaining_period": "Duració restant previsible de contracte",
	"Cooperatives": "Cooperatives",
	"Corrected_market_value": "Valor de mercat corregit",
	"Corrected_unit_market_value": "Valor unitari corregit",
	"Correction": "Correcció",
	"Correction_of_values": "Correcció de valors",
	"Cost_method": "Mètode del cost",
	"Council_classification": "Classificació Ajuntament",
	"Council_classification_description": "Descripció Classificació Ajuntament",
	"Council_qualification": "Qualificació Ajuntament",
	"Council_qualification_description": "Descripció Qualificació Ajuntament",
	"Regional_classification": "Classificació MUC",
	"Regional_classification_description": "Descripció Classificació MUC",
	"Regional_qualification": "Qualificació MUC",
	"Regional_qualification_description": "Descripció Qualificació MUC",
	"Country": "País",
	"Country_s_State": "País / Estat",
	"Covered_outdoor_area": "Superfícies exteriors cobertes",
	"Create_a_new_contact": "Crear un nou contacte",
	"Created": "Creat",
	"Creation": "Creació",
	"Current_reversion_value_calculation": "Càlcul del valor actual de reversió",
	"Current_value_of_future_rents": "Valor actual de rendes futures",
	"Customer_Service": "Servei d'Atenció al Client",
	"Customer_Service_text_01": "posa a disposició dels seus clients el seu",
	"Customer_Service_text_02": "al que els seus clients poden dirigir les queixes, suggerències i reclamacions relacionades amb el servei donat per la Societat",
	"Customer_Service_text_03": "Les funcions del SAC són",
	"Customer_Service_text_04": "Atendre i resoldre les queixes, reclamacions i consultes presentades, directa o mitjançant representació, via persones físiques o jurídiques, nacionals o extrangeres, clients de la Societat, quan aquestes es refereixin a interessos o drets legalment reconeguts relacionats amb operacions, contractes o serveis donats per l'empresa, tant si deriven dels propis contractes, de la normativa de transparencia i protecció de la clientela o de les bones pràctiques i usos, en particular del principi d'equitat",
	"Customer_Service_text_05": "Fer arribar a la direcció de l'empresa les recomanacions i suggerències sobre tots aquells aspectes que, en la seva opinió, suposin un enfortiment de les bones relacions i mútua confiança que ha d'existir entre l'empresa i els seus clients",
	"Customer_Service_text_06": "Els deures d'informació del SAC queden recollits a la legislació vigent Ordre ECO/734/2004, de 11 de març, sobre els departaments i serveis d'atenció al client de les entitats financeres",
	"Customer_Service_text_07": "Accés al Reglament del Servei d'Atenció al Client de BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Accés al full de reclamacions",
	"Customer_Service_text_09": "Legislació aplicable per a la defensa del client de serveis financers",
	"Customer_Service_text_10": "Llei 2/2011 de 4 de març d'Economia Sostenible",
	"Customer_Service_text_11": "Ordre ECC/2502/2012 de 16 de novembre, a través de la qual es regula el procediment de presentació de reclamacions davant dels serveis de reclamacions del Banco de España, la Comissió Nacional del Mercat de Valors i la Direcció General d'Assegurances i Fons de Pensions",
	"Customer_Service_text_12": "Ordre ECO/734/2004. De 11 de març, sobre els departaments i serveis d'atenció al client i el defensor del client de les entitats financeres",
	"Customer_Service_text_13": "Pot contactar amb nosaltres a través dels següents mitjans",
	"Customer_Service_text_14": "En persona, a l'oficina d'atenció al públic del Servei d'Atenció al Client (de 10h a 13h i de 16h a 19h). Adreça",
	"Customer_Service_text_15": "Per correu certificat dirigit a",
	"Customer_Service_text_16": "Posem a disposició dels clients un formulari de queixes i reclamacions, que trobarà en aquest",
	"Customer_Service_text_17": "El formulari és de caràcter voluntari i haurà de incloure la següent informació",
	"Customer_Service_text_18": "Nom i cognoms de l'interessat",
	"Customer_Service_text_19": "Domicili de l'interessat (i si fós el cas, de la persona que el representi)",
	"Customer_Service_text_20": "Per a persones físiques: el NIF de l'interessat",
	"Customer_Service_text_21": "Per a persones jurídiques: el CIF i les dades de registre mercantil",
	"Customer_Service_text_22": "Motiu de la queixa, especificant amb claredat les qüestions sobre les que es sol·licita un pronunciament",
	"Customer_Service_text_23": "Nº d'expedient de taxació",
	"Customer_Service_text_24": "Lloc, data i firma",
	"Customer_Service_text_25": "Proves documentals (donat el cas)",
	"Customer_Service_text_26": "En el cas d'haver-se esgotat les vies disponibles a través del Departament d'Atenció al Client (haver-se denegat, desestimat o haver transcorregut més de dos mesos sense resolució), es podrà presentar una reclamació al Departamento de Conducta de Mercado y Reclamaciones del Banco de España, amb les següents dades de contacte",
	"Customer_Service_text_27": "O per via telemàtica a través de l'Oficina Virtual",
	"Data": "Dades",
	"Data_of_property_to_be_appraised": "Dades de l'immoble a taxar",
	"Data_tabulation": "Tabulació de dades",
	"date": "data",
	"Date": "Data",
	"Date_of_the_appraisal_value": "Data del valor de taxació",
	"Date_of_report": "Data de l'informe",
	"Date_of_quote": "Data del pressupost",
	"Date_of_invoice": "Data de la factura",
	"Delete": "Eliminar",
	"Deprecated_construction_cost": "Cost de construcció depreciat",
	"Depreciation_by_antiquity": "Depreciació per antiguitat",
	"description": "descripció",
	"Description": "Descripció",
	"Discard": "Descartar",
	"Distance": "Distància",
	"Door": "Porta",
	"Duplicate": "Duplicar",
	"Dwelling_type": "Tipus d'habitatge",
	"Dwellings": "Habitatges",
	"e-mail": "correu electrònic",
	"E-mail": "Correu electrònic",
	"E-mail_address": "Adreça de correu electrònic",
	"E-mail_addresses": "Adreces de correu electrònic",
	"E-mail_description": "Descripció del correu electrònic",
	"Email": "Correu electrònic",
	"Email address": "Adreça de correu electrònic",
	"Edit": "Editar",
	"Edit_ad": "Editar anunci",
	"Edit_address": "Editar adreça",
	"Edit_Appraisal": "Editar taxació",
	"Edit_contact": "Editar contacte",
	"Edit_real_estate": "Editar immoble",
	"Edit_Real_Estate": "Editar Immoble",
	"Email_Address": "Adreça de correu electrònic",
	"Energy_Certificates": "Certificats Energètics",
	"Energy_Efficiency_Certificate": "Certificat d'Eficiència Energètica",
	"Entities": "Entitats",
	"Entities_Index": "Índex d'Entitats",
	"Entity": "Entitat",
	"EPSG_missing_text": "Manquen les coordenades X i Y EPSG:25831 per a poder obtenir la referència cadastral i el codi de secció censal. Es poden consultar amb el botó de Geolocalitzar",
	"Estimated_sale_price": "Preu de venta estimat",
	"Estimated_unit_sale_price": "Preu unitari estimat",
	"Estimated_useful_life": "Vida útil estimada",
	"Executed_construction_cost": "Cost de construcció realitzada",
	"Expected_Income_Update_Method": "Mètode Actualització de Renda Esperada",
	"Experience": "Experiència",
	"Experience_text": "Més de 30 anys de trajectòria oferint el millor servei al millor preu",
	"Expert_Opinions": "Dictàmens Pericials",
	"expert_opinions": "dictàmens pericials",
	"Expropriations": "Expropiacions",
	"External_storage_room": "Traster",
	"features": "característiques",
	"Features": "Característiques",
	"Fees": "Honoraris",
	"file": "expedient",
	"File": "Expedient",
	"File_description": "Descripció de l'expedient",
	"Files": "Expedients",
	"File_number": "Nº d'expedient",
	"Final_unit_price": "Preu unitari final",
	"Financial_Entities": "Entitats Financeres",
	"finished_real_estate": "immoble acabat",
	"finishes": "acabats",
	"Finishes": "Acabats",
	"Fiscal_Address": "Adreça Fiscal",
	"Fiscal_address": "Adreça fiscal",
	"fixtures": "instal·lacions",
	"Fixtures": "Instal·lacions",
	"Floor": "Planta",
	"Floor_number": "Nº Planta",
	"Floor_type": "Tipus de planta",
	"For_all_purposes": "Per a totes les finalitats",
	"Foundations": "Fundacions",
	"Freemarket_benefit": "Benefici mercat lliure",
	"Fri.": "Dv.",
	"from": "de",
	"Functional_depreciation": "Depreciació funcional",
	"General_data": "Dades generals",
	"Green_areas": "Jardí / Zones enjardinades",
	"Have_an_account_q_Log_in": "Ja tens un compte? Inicia sessió",
	"Heating": "Calefacció",
	"Height_situation": "Situació en alçada",
	"Higher_values": "Valors superiors",
	"Home_text_01": "Bonell+Dòriga architects, Barcelona",
	"homogenisation": "homogeneïtzació",
	"Homogenisation": "Homogeneïtzació",
	"Homogenisation_of_values": "Homogeneïtzació de valors",
	"Homologated_company": "Societat Homologada",
	"Homologated_Appraisal_Company_c_since_1995": "Societat de Taxació Homologada, des de 1995",
	"Homologated_text_01_part01": "Inscrita en el",
	"Homologated_text_01_part02": "d'Entitats de Taxació del Banco de España, amb nº 4.470 i data 26/06/1.995",
	"Honorarium_c_taxes_and_licenses": "Honoraris facultatius, taxes i llicències",
	"Honorarium_c_taxes_and_licenses_percentage": "Percentatge d'honoraris facultatius, taxes i llicències",
	"Hospitals": "Hospitals",
	"Hotels": "Hotels",
	"Decennial_insurance_policy_expenses": "Despeses de pòlissa d'assegurança decennal",
	"Decennial_insurance_policy_expenses_percentage": "Percentatge de despeses de pòlissa d'assegurança decennal",
	"Developers_administrative_expenses": "Despeses administratives del promotor",
	"Developers_administrative_expenses_percentage": "Percentatge de despeses administratives del promotor",
	"Developers_benefit": "Benefici del promotor",
	"Development_expenses": "Despeses de promoció",
	"Development_expenses_percentage": "Percentatge de despeses de promoció",
	"Other_elements_included_in_this_valuation_price": "Altres elements inclosos en aquesta valoració",
	"Geographical_area": "Àmbit geogràfic",
	"Geolocate": "Geolocalitzar",
	"go_back": "tornar enrere",
	"Go_back": "Tornar enrere",
	"go_up": "tornar amunt",
	"Go_up": "Tornar amunt",
	"Gross_Replacement_Cost": "Cost de Reemplaçament-reposició Brut",
	"Gross_yearly_rent_income": "Renda bruta anual de lloguer",
	"Geolocation": "Geolocalització",
	"Identification": "Identificació",
	"in_01": "en",
	"In_accordance_with_eco_decree_q": "s/ Ordre ECO?",
	"In_accordance_with_mortgage_market_law_q": "s/ Llei del Mercat Hipotecari?",
	"Independence": "Independència",
	"Independent_professionals": "Professionals independents",
	"Independent_pl": "Independents",
	"Index_of_Appraisals": "Índex de Taxacions",
	"Individuals": "Particulars",
	"Industrial_warehouses": "Naus industrials",
	"Info_source": "Font de la informació",
	"Infrastructures": "Infraestructures",
	"Paving_execution_pct": "Percentatge d'execució de pavimentació",
	"Sewage_execution_pct": "Percentatge d'execució de clavegueram",
	"Public_lighting_execution_pct": "Percentatge d'execució d'enllumenat públic",
	"Water_supply_execution_pct": "Percentatge d'execució de subministrament d'aigua",
	"Electricity_supply_execution_pct": "Percentatge d'execució de subministrament elèctric",
	"Piped_gas_execution_pct": "Percentatge d'execució de gas canalitzat",
	"Telephone_service_execution_pct": "Percentatge d'execució de servei telefònic",
	"Gardened_areas_execution_pct": "Percentatge d'execució de zones enjardinades",
	"Total_execution_pct": "Percentatge d'execució total infraestructures",
	"Infrastructures_repercussion_cost": "Cost de repercussió infraestructures",
	"Pending_investment": "Inversió pendent",
	"Paving": "Pavimentació",
	"Sewage": "Clavegueram",
	"Public_lighting": "Enllumenat públic",
	"Electricity_supply": "Subministrament electricitat",
	"Piped_gas": "Gas canalitzat",
	"Telephone_service": "Servei telefònic",
	"Gardened_areas": "Zones enjardindes",
	"Land_is_plot_according_to_law": "Té el terreny consideració de solar segons la Llei del Sòl?",
	"Notes_on_plot_infrastructures": "Observacions sobre les infraestructures",
	"Notes_on_plot_area": "Observacions sobre la superfície del terreny",
	"Informative_Appraisal_Fees": "Honoraris Taxació Informativa",
	"Initial_Data": "Dades Inicials",
	"Initial_unit_price": "Preu unitari inicial",
	"Innovation": "Innovació",
	"Insurance_companies": "Companyies d'assegurances",
	"Insurance_value": "Valor de l'assegurança",
	"Interior_visit_check": "Visita interior",
	"Internal_regulation": "Reglament intern",
	"Invalid_email_address": "L'adreça d'e-mail és incorrecta",
	"Investment_groups": "Grups d'inversió",
	"Invoices": "Factures",
	"Is_it_rented_or_ceded_q": "L'immoble està llogat o cedit?",
	"Is_the_real_estate_protected_q": "L'immoble està protegit?",
	"Is_the_right_of_use_ceded_q": "El dret d'ús de l'immoble està cedit?",
	"land": "sòl",
	"Land": "Sòl",
	"Land_area": "Superfície de terreny",
	"Land_registry_area": "Superfície registral del terreny",
	"Land_market_value": "Valor de mercat del sòl",
	"Land_pl": "Terrenys",
	"Land_total_value": "Valor total del sòl",
	"Land_value": "Valor del sòl",
	"Land_value_plus_deprecated_construction_cost": "Valor del sòl més cost de construcció depreciat",
	"Land_value_plus_executed_construction_cost": "Valor del sòl més cost de construcció realitzada",
	"Landlord_expenses_pct": "Percentatge net restant degut a despeses del arrendador",
	"Language": "Idioma",
	"Last_modified": "Última modificació",
	"last_renovation_year": "últim any de rehabilitació",
	"Last_renovation_year": "Últim any de rehabilitació integral",
	"Appraisal_adopted_area_missing_error_text": "Manca introduir la superfície construïda de l'immoble de referència per a poder procedir amb l'estudi de mercat",
	"Appraisal_property_type_missing_error_text": "Manca introduir el tipus d'immoble corresponent a l'immoble de referència per a poder procedir amb l'estudi de mercat",
	"Lat_lng_missing_error_text": "Manca introduir les coordenades de latitud i longitud per a l'immoble actual",
	"Ad_type_missing_error_text": "Manca introduir el tipus d'anunci que es vol obtenir per a poder fer la consulta",
	"Date_missing_error_text": "Manca introduir el rang de dates (inici i final) per a poder consultar els anuncis",
	"Adopted_age_missing_error_text": "Manca introduir l'antiguitat considerada per a poder proseguir",
	"Adopted_age_length_error_text": "L'antiguitat considerada ha de ser un any amb format 'YYYY'",
	"Adopted_area_missing_error_text": "Manca introduir la superfície construida adoptada per a poder proseguir",
	"Property_type_missing_error_text": "Manca introduir el tipus d 'immoble per a poder proseguir",
	"Latitude": "Latitud",
	"Law_firms": "Despatxos jurídics",
	"Lift": "Ascensor",
	"link": "Enllaç",
	"Loading": "Carregant",
	"Log_In": "Inicia la sessió",
	"Longitude": "Longitud",
	"Looking_for_something_q": "Buscant alguna cosa?",
	"Lower_limit": "Límit inferior",
	"Market": "Mercat",
	"Market_calculations": "Càlculs del mercat",
	"Market_studies_for_this_real_estate": "Estudis de mercat per a aquest immoble",
	"Market_study": "Estudi de mercat",
	"Market_study_for": "Estudi de mercat per a",
	"Market_unit_value": "Valor unitari de mercat",
	"Market_value": "Valor de mercat",
	"Machinery": "Maquinària",
	"Market_coeficient": "Coeficient de mercat",
	"Market_value_adjustment": "Ajust del valor de mercat",
	"Market_value_of_the_appraised_realestate": "Valor de mercat de l'immoble taxat",
	"Market_value_reduction_pct": "Reducció valor mercat (%)",
	"Market_studies": "Estudis de mercat",
	"Material_execution_cost": "Cost d'execució material",
	"Materials": "Materials",
	"Maximum_legal_computable_area": "Superfície legal màxima computable",
	"Maximum_legal_sale_price": "Preu de venta màxim legal",
	"Maximum_Legal_Method": "Mètode Màxim Legal",
	"Measurements": "Amidaments",
	"Mec_adjustment_coef": "Coeficient d'ajust del cost d'execució material",
	"Medical_centers": "Centres mèdics",
	"Messages": "Missatges",
	"Metadata": "Metadades",
	"Minimum_benefit_acc_to_regulation": "Benefici mínim segons la norma",
	"Minimum_fees": "Honoraris mínims",
	"Modification": "Modificació",
	"Modified": "Modificat",
	"Mon.": "Dl.",
	"Mortgage_Appraisal_Fees": "Honoraris Taxació Hipotecària",
	"Municipality": "Municipi",
	"Mutual_insurance_companies": "Mútues",
	"Name": "Nom",
	"Name_and_surnames": "Nom i cognoms",
	"Name_and_TIN": "Nom i NIF/CIF",
	"net_area": "superfície útil",
	"Net_area": "Superfície útil",
	"Net_areas": "Superfícies útils",
	"Net_yearly_rent_income": "Renda neta anual de lloguer",
	"Net_Replacement_Cost": "Cost de Reemplaçament-reposició Net",
	"New_address": "Nova adreça",
	"New_appraisal_file": "Nou expedient de taxació",
	"New_contact": "Nou contacte",
	"New_entity": "Nova entitat",
	"Number": "Número",
	"Number_of_floors_and_use": "Nº de plantes i ús",
	"No_address_registered": "Cap adreça registrada",
	"No_contact_registered": "Cap contacte registrat",
	"No_email_address_registered": "Cap adreça de correu electrònic registrada",
	"No_telephone_number_registered": "Cap nº de telèfon registrat",
	"No_results": "Cap resultat",
	"Non_recoverable_taxes_percentage": "Percentatge d'impostos no recuperables",
	"Non_recoverable_taxes": "Impostos no recuperables",
	"Not_found_message": "No s'ha trobat la pàgina, comprova que la URL sigui correcta",
	"notes": "observacions",
	"Notes": "Observacions",
	"Notes_1": "Observacions 1",
	"Notes_2": "Observacions 2",
	"Notes_on_mortgage_valuation_validity": "Observacions sobre la validesa de la taxació per a fins hipotecaris",
	"Occupancy_Card": "Cèdul·la d'Habitabilitat",
	"Occupancy_Cards": "Cèdul·les d'habitabilitat",
	"Occupancy_Card_and_Certificate": "Certificat i Cèdul·la d'Habitabilitat",
	"Occupancy_Certificate": "Certificat d'Habilitat",
	"occupancy_certificates": "cèdul·les d'habitabilitat",
	"of": "de",
	"of_the_excess_of": "de l'excés de",
	"of_the_same_property": "del mateix immoble",
	"Offer_price": "Preu de l'oferta",
	"Offer_unit_price": "Preu unitari de l'oferta",
	"Official_Appraisals": "Taxacions Oficials",
	"Office_hours": "Horari d'oficines",
	"Official_appraisals_for_all_purposes": "Taxacions oficials per a tota finalitat",
	"Official_Register": "Registre Oficial",
	"Offices": "Oficines",
	"Open": "Obrir",
	"Open_link_in_new_tab": "Obrir link en una nova pestanya",
	"Orientation": "Orientació",
	"Organization_s_Company": "Organització / Empresa",
	"Other_services": "Altres serveis",
	"other_services": "altres serveis",
	"others": "altres",
	"Our_clients": "Els nostres clients",
	"Our_services": "Nuestros servicios",
	"Our_workflow": "Nuestro flujo de trabajo",
	"PA_registration_number": "Nº col·legiat",
	"Page_not_found": "Pàgina no trobada",
	"Parking_lots_number": "nº Places d'aparcament",
	"Parking_spaces": "Places d'aparcament",
	"Password": "Contrassenya",
	"Person_type": "Tipus de persona",
	"Petitioner": "Sol·licitant",
	"Petitioner_data": "Dades del sol·licitant",
	"Petitioner_type": "Tipus de sol·licitant",
	"Philosophy": "Filosofia",
	"Philosophy_text_01": "La filosofia de la societat es pot resumir en tres principis fonamentals: professionalitat, rapidesa i ètica. Tot plegat unit a un bon equip de professionals i a un control de qualitat exhaustiu",
	"Philosophy_text_02": "Els nostres valors defineixen la nostra identitat com a empresa i constitueixen la força propulsora de com fem dia a dia el nostre treball. Considerem que el nostre èxit és conseqüència dels mateixos, entre els quals destaquem",
	"Philosophy_text_03": "Auditoria contínua dels nostres processos de realització de taxacions i valoracions amb la implementació de les últimes tecnologies. BARNA-TAXA, SA disposa de programari especialment desenvolupat per a l'exercici de la valoració emprant les eines informàtiques més adequades. Tots els nostres informes incorporen certificació de firma digital",
	"Philosophy_text_04": "És una societat l'accionariat i junta directiva és privat i NO VINCULAT a cap entitat financera ni grup immobiliari. BARNA-TAXA, S. A. no intermèdia en operacions de compravenda en el mercat, pel que els seus serveis es presten des de la més absoluta independència",
	"Philosophy_text_05": "Capacitat de resposta contrastada, efectivitat i equilibri de les nostres valoracions. Compromís de complir els requisits i processos necessaris per a la satisfacció del client",
	"Philosophy_text_06": "El nostre sistema de qualitat es basa en els següents principis: La millora contínua i superació com a objectiu permanent, la qual cosa s'aconsegueix especialment a través del compromís de tota l'organització i l'anàlisi sistemàtica dels resultats de qualitat. Satisfer les necessitats i expectatives dels clients, complint els temps de lliurament acordats amb els clients i treballant en la millora dels mateixos, lliurant sempre un bon producte a la primera. El compliment dels requisits, ja siguin reglamentaris i legals, particulars dels nostres clients o de qualsevol altra índole, donant així resposta a totes les parts interessades",
	"Philosophy_text_07": "Assegurar el compliment de la normativa vigent i la feina ben feta",
	"Philosophy_text_08": "El fet d'estar homologats i inscrits amb el número 4.470 en el Registre de Societats de Taxació del Banc d'Espanya i estar subjectes a la supervisió, garanteix el rigor l'objectivitat i la transparència absoluta dels nostres informes de valoració",
	"Philosophy_text_09": "Més de tres dècades en el camp de la taxació avalen el nostre treball",
	"Philosophy_text_10": "La confidencialitat dels treballs que la normativa exigeix, està garantida pel secret professional que regeix la conducta dels nostres tècnics. BARNA-TAXA S.A. no revela informació a terceres persones",
	"Philosophy_text_11": "BARNA-TAXA, S. A. estableix un marc de conducta per a la societat i els seus treballadors",
	"Physical_depreciation": "Depreciació física",
	"Pick_an_option": "Selecciona una opció",
	"Plan_type": "Tipus de pla",
	"Plot_area": "Superfície del solar",
	"Please_enter_a_name": "Per favor, introdueixi el nom del sol·licitant",
	"Please_enter_a_surname": "Per favor, introdueixi el cognom del sol·licitant",
	"Please_enter_a_telephone_number": "Per favor, introdueixi un número de telèfon",
	"Please_enter_an_email_address": "Per favor, introdueixi una adreça d'e-mail",
	"Please_enter_the_type_of_property": "Per favor, introdueixi el tipus de immoble a taxar",
	"Please_enter_the_address_of_the_property": "Per favor, introdueixi l'adreça de l'immoble",
	"Please_enter_the_postal_code": "Per favor, introdueixi el codi postal de l'immoble",
	"Please_enter_the_municipality": "Per favor, introdueixi el municipi",
	"Please_enter_the_area_of_the_property": "Per favor, introdueixi la superfície de l'immoble",
	"Please_enter_the_purpose_of_the_appraisal": "Per favor, introdueixi la finalitat de la taxació",
	"Postal_code": "Codi postal",
	"Prefix": "Prefix",
	"Price": "Preu",
	"Pricing": "Tarifes",
	"Pricing_and_Quotes": "Tarifes i Pressupost",
	"Pricing_text_01": "Oferim dos tipus de valoracions: la valoració hipotecària i la valoració informativa, segons la seva finalitat",
	"Pricing_text_02": "Obtindrà en un plaç màxim de 24h el pressupost per escrit de la seva taxació, sense compromís",
	"Pricing_text_03": "Descompte per volum d'encàrrec. IVA APLICABLE: 21%",
	"Pricing_text_04": "Taxació hipotecària: Regulada per la normativa ECO 805/2003 i disposicions concordants",
	"Pricing_text_05": "Les localitats fora de Barcelona capital i àrea metropolitana tindran increment per desplaçament",
	"Pricing_text_06": "Descompte especial per a les comandes de Informe de Taxació + Certificat d'un mateix immoble",
	"Print_report_in_PDF": "Imprimir informe en PDF",
	"Private_Enterprises": "Empreses Privades",
	"Professional_association": "Col·legi professional",
	"Professional_ethics": "Ètica professional",
	"Professional_qualification": "Titulació",
	"Professionalism": "Professionalitat",
	"Professionals_text_01_part_01": "Una societat d'",
	"Professionals_text_01_part_02": "arquitectes, enginyers i especialistes totalment independents",
	"Professionals_text_01_part_03": ", sense vinculació amb entitats financeres ni grups empresarials",
	"Properties_under_economic_exploitation": "Immobles en explotació econòmica",
	"Professionals_with_experience": "Professionales con experiencia",
	"Properties": "Immobles",
	"Property_data": "Dades de l'immoble",
	"Property_developers": "Promotors Immobiliaris",
	"Property_developments": "Promocions immobiliàries",
	"Property_purchase-sale": "Compra-venta d'immobles",
	"Property_type": "Tipus d'immoble",
	"Property_types": "Tipus d'immobles",
	"Property_valuation_services": "Serveis de valoració immobiliària",
	"Property_visit": "Visita a l'immoble",
	"protection": "protecció",
	"Protection": "Protecció",
	"Protection_type": "Tipus de protecció",
	"Protection_regime": "Règim de protecció",
	"Protection_zone": "Zona de protecció",
	"Province": "Provincia",
	"Public_Administrations": "Administracions públiques",
	"purpose": "finalitat",
	"Qualities": "Qualitats",
	"Qualities_comparison": "Comparació de qualitats",
	"Quality": "Qualitat",
	"Quality_of_construction": "Qualitat de la construcció",
	"Quality_of_neighbourhood": "Qualitat del barri",
	"Quality_of_realestate": "Qualitat de l'element",
	"Quality_of_situation": "Qualitat de la situació",
	"Query_comparables": "Consultar comparables",
	"Query_real_estates": "Consultar immobles",
	"Query_result": "Resultat de la consulta",
	"Quote_request": "Sol·licitud de pressupost",
	"Quotes": "Pressupostos",
	"Real_estate": "Immoble",
	"Real_estates": "Immobles",
	"Real_estates_index": "Índex d'immobles",
	"Real_Estates_residual_value": "Valor residual de l'immoble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Valor residual de l'immoble al final de la vida útil del contracte",
	"Real_estate_referral": "Immoble de referència",
	"Real_estate_value": "Valor de l'immoble",
	"Realestates_remaining_useful_life": "Vida útil restant de l'immoble",
	"RealEstate_description": "Descripció de l'immoble",
	"Reduction": "Reducció",
	"Reduction_pct": "Reducció (%)",
	"Registry_data": "Dades registrals",
	"Registry_identification_data": "Identificació registral",
	"Register_name": "Nom del Registre",
	"Regression_line": "Línia de regressió",
	"Regression_line_calculation": "Càlcul de la línia de regressió",
	"Remaining_contract_years": "Anys restants de contracte",
	"Remaining_of_the_developers_benefit": "Restant del benefici del promotor",
	"Remaining_period_update": "Actualització del període restant",
	"Repercussion_method": "Mètode de repercussió",
	"Report": "Informe",
	"Report_title_missing_error_text": "Manca el títol de l'informe",
	"reports": "informes",
	"Report_content": "Contingut de l'informe",
	"Report_content_text_01": "Visita a l'immoble i elaboració d'informe oficial realitzat per un tècnic qualificat de Barna-Tasa",
	"Report_content_text_02": "Identificació i localització. Característiques de l'immoble. Dades cadastrals i registrals",
	"Report_content_text_03": "Fotografies i croquis de l'immoble",
	"Report_content_text_04": "Estudi de mercat real, selecció de mostres i càlcul de valors de l'informe",
	"Report_date": "Data de l'informe",
	"Report_number": "Nº d'informe",
	"Report_title": "Títol de l'informe",
	"Representative": "Representant",
	"representative_sample": "mostra representativa",
	"Representative_sample": "Mostra representativa",
	"Representative_TIN": "NIF del representant",
	"Report_language": "Idioma de l'informe",
	"Requesting": "Sol·licitant",
	"Request_a_quote": "Sol·licitar pressupost",
	"Request_a_quote_24h": "Sol·liciti pressupost (24h)",
	"Request_a_quote_here": "Sol·liciti pressupost aquí",
	"Request_a_quote_for_an_appraisal": "Sol·licitar pressupost de taxació",
	"Request_successfully_sent": "Sol·licitud correctament enviada",
	"Required_fields": "Camps necessaris",
	"Residual_depreciation": "Depreciació residual",
	"Residual_value": "Valor residual",
	"Restaurants": "Restaurants",
	"Restringit": "Restringit",
	"Right_of_use": "Dret d'ús",
	"Right_of_use_value": "Valor del dret d'ús",
	"rights": "drets",
	"Rights": "Drets",
	"Rigor": "Rigor",
	"Risk_premium": "Prima de risc",
	"Riskfree_rate": "Taxa lliure de risc",
	"Room": "Habitació",
	"Rooms": "Habitacions",
	"Sat.": "Ds.",
	"Save": "Desar",
	"Save_and_go_back": "Desar i tornar",
	"Save_valuation": "Desar taxació",
	"Search_radius_km": "Radi de búsqueda (km)",
	"Security": "Seguretat",
	"Selected_comparables": "Comparables seleccionats",
	"Send_to_bde_q": "Enviar al BdE?",
	"Services": "Serveis",
	"Services_text_01": "BARNA-TASA, S.A. és una societat especialitzada en la VALORACIÓ DE BÉNS, homologada i registrada al 'Banco de España' amb el número 4.470 en el Registro Oficial de Entidades de Tasación. La nostra experiència es basa en més de 30 anys d'exercici professional en l'àmbit de taxacions, valoracions i peritatges de la construcció",
	"Services_text_02": "El nostre principal servei s'emmarca en el camp de les valoracions i les taxacions amb totes les finalitats. També oferim un ventall de serveis relacionats amb el món de la arquitectura i el peritatge, des de la el·laboració de dictàmens i peritatges de construcció fins a certificats, cèdul·les i aixecaments de plànols",
	"Services_text_03": "Realitzem taxacions per a totes les finalitats. Oferim dos tipus de taxacions segons la seva finalitat",
	"Services_text_04": "La tipologia habitual de béns immobles i drets que valorem mitjançant el corresponent informe de taxació és la següent",
	"Services_text_05": "Acceptació de l'encàrrec i entrega de documentació necessària",
	"Services_text_06": "Visita al immoble per part d'un tècnic de BARNA-TASA",
	"Services_text_07": "El·laboració de l'informe o informes per part de BARNA-TASA",
	"Services_text_08": "Entrega de l'informe en format digital i/o paper",
	"Sign_Up": "Registra't",
	"Source": "Font",
	"Sports_clubs": "Clubs esportius",
	"Sports_facilities": "Instal·lacions esportives",
	"Staircase": "Escala",
	"Standard_deviation_of_the_sample": "Desviació estàndard de la mostra",
	"Storerooms": "Trasters",
	"Street_name": "Nom de via",
	"Street_number": "Nº via",
	"Structure": "Estructura",
	"Sun.": "Dg.",
	"Supervisor": "Supervisor",
	"Surnames": "Cognoms",
	"Surnames_name": "Cognoms, Nom",
	"Surnames_name_or_company": "'Cognoms, Nom' o 'Nom de l'empresa'",
	"Surroundings": "Entorn",
	"Surveying": "Aixecament de plànols",
	"Swimming_pool": "Piscina",
	"Tasks": "Tasques",
	"Taxes": "Impostos",
	"technical_values": "valors tècnics",
	"Technical_values": "Valors tècnics",
	"Technology": "Tecnologia",
	"Team_text": "La societat està formada per un grup d'arquitectes, enginyers i especialistes en taxacions amb un ampli coneixement sobre el mercat immobiliari i amb una experiència contrastada de més de 30 anys en el camp de la valoració immobiliària",
	"Teamwork": "Treball en equip",
	"Telephone": "Telèfon",
	"Telephone_contact": "Telèfon de contacte",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Nº de Telèfon",
	"Telephone_numbers": "Números de telèfon",
	"Tenant_age_years": "Edat de l'arrendatari",
	"Tenant_life_expectancy_years": "Esperança de vida",
	"Tenant_remaining_life_expectancy_years": "Vida restant estimada arrendatari",
	"Terrain": "Terreny",
	"Testamentary_shares": "Participacions testamentàries",
	"The_company": "L'Empresa",
	"The_page_contains_unsaved_changes": "La pàgina actual conté canvis no desats",
	"The_passwords_do_not_match": "Les contrassenyes no coincideixen",
	"thousand": "mil",
	"thousand_euros": "mil euros",
	"thousands_of_euros": "milers d'euros (€)",
	"Thu.": "Dj.",
	"TIN": "NIF / CIF",
	"Title": "Títol",
	"Title_and_date_of_report": "Títol i data de l'informe",
	"Title_s_Honorific": "Títol / Tractament",
	"to": "a",
	"Total_depreciation": "Depreciació total",
	"Total_value": "Valor total",
	"total_values": "valors totals",
	"Total_values": "Valors totals",
	"Transparency": "Transparència",
	"Trust": "Confiança",
	"type": "tipus",
	"Type": "Tipus",
	"Type_here_to_filter_paginated_data": "Escriu aquí per filtrar les dades paginades",
	"Typical_deviation": "Desviació típica",
	"Typology": "Tipologia",
	"Others": "Altres",
	"Type_of_property": "Tipus d'immoble",
	"Uncovered_outdoor_area": "Superfícies exteriors descobertes",
	"Unit_price": "Preu unitari",
	"Unit_value": "Valor unitari",
	"universal_sample": "mostra universal",
	"Universal_sample": "Mostra universal",
	"Update_type": "Tipus d'actualització",
	"Update_value": "Valor d'actualització",
	"Update_value_calculation": "Càlcul del valor d'actualització",
	"Updated_reversion_value": "Valor de reversió actualitzat",
	"Upper_limit": "Límit superior",
	"Urban_planning_parameters": "Paràmetres urbanístics",
	"Url": "Link",
	"Useful_life": "Vida útil",
	"Usufruct": "Usdefruit",
	"Usufruct_value": "Valor de l'usdefruit",
	"Usufructuary_age_years": "Edat de l'usufructuari",
	"valuated_in_this_report": "valorats en aquest informe",
	"Valuation": "Valoració",
	"Valuation_pricing": "Tarifes de taxació",
	"valuations": "valoracions",
	"Valuation_date": "Data de valoració",
	"Valuation_purpose": "Finalitat de la valoració",
	"Valuation_report": "Informe de valoració",
	"Valuation_type": "Tipus de valoració",
	"Value_date": "Data del valor",
	"Version": "Versió",
	"Visits": "Visites",
	"VAT": "IVA",
	"Warnings": "Advertiments",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "Ho sentim, no trobem la pàgina sol·licitada",
	"Weighing": "Ponderació",
	"Welcome_message": "Benvingut a la App de Barnatasa",
	"What_you_need_to_provide": "Què necessites aportar?",
	"with": "amb",
	"without_saving": "sense desar",
	"Workflow": "Flux de treball",
	"Wrong_date_message": "La data és incompleta o incorrecta",
	"years": "anys",
	"You_are_about_to_delete": "S'eliminarà",
	"Registry_area": "Superfície Registral",
	"Checked_area": "Superfície comprovada",
	"Plot_occupation": "Ocupació del solar",
	"Plot_free_area_usage": "Ús de la superfície lliure del solar",
	"Floors_number_underground": "Nª de plantes sota rasant",
	"Floors_number_overground": "Nº de plantes sobre rasant",
	"Parking_slots_included_in_appraisal_number": "Nº de places de garatge incloses en la valoració",
	"Entrance_hall": "Portal",
	"Doorman_space": "Porteria",
	"Community_room": "Sala comunitària",
	"Storage_room_included_in_appraisal": "Traster inclòs",
	"Community_parking": "Garatge",
	"Facilities_others": "Altres",
	"Floors_usage_underground": "Ús sota rasant",
	"Floors_usage_overground": "Ús sobre rasant",
	"Groundfloor_usage": "Ús planta baixa",
	"Real_estates_useful_life": "Vida útil de l'immoble",
	"Real_estates_total_useful_life": "Vida útil total de l'immoble",
	"Remaining_useful_life_years": "Anys restants de vida útil",
	"Urban_and_surroundings_text": "Urbanisme i entorn",
	"Communications": "Comunicacions",
	"Airport": "Aeroport",
	"Harbour": "Port",
	"Train": "Tren",
	"Public_transport": "Transport públic",
	"Urban_underground": "Urbà subterrani",
	"Interurban": "Interurbà",
	"Territorial_feature": "Característica territorial",
	"Income_level": "Nivell de la renta",
	"Homogeneity_feature": "Trets d'homogeneïtat",
	"Main_uses": "Usos dominants",
	"Density": "Densitat",
	"Accessibility": "Accessibilitat",
	"Consolidation_degree": "Grau de consolidació",
	"Occupation_degree": "Grau d'ocupació",
	"Evolution": "Evolució",
	"Average_age": "Antiguitat característica",
	"Commercial": "Comercial",
	"Educational": "Educacional",
	"Public_parking": "Aparcament públic",
	"Medical_assistance": "Assistència mèdica",
	"Leisure": "Oci",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipaments",
	"MUC_map": "Mapa del MUC",
	"Registry": "Registre",
	"Section": "Secció",
	"Volume": "Volum",
	"Book": "Llibre",
	"Page": "Pàgina",
	"Registry_real_estate_number": "Nº de finca registral",
	"Holder": "Titular",
	"Property_coef": "Coeficient de propietat",
	"Bedrooms_and_bathrooms": "Dormitoris i banys",
	"Covered_outdoor_areas": "Superfícies exteriors cobertes",
	"Uncovered_outdoor_areas": "Superfícies exteriors descobertes",
	"Add_covered_outdoor": "Afegir espai exterior cobert",
	"Add_uncovered_outdoor": "Afegir espai exterior descobert",
	"Enclosed_area": "Superfície tancada",
	"Enclosed_checked_area": "Superfície tancada comprovada",
	"Low_enclosed_checked_area_error_text": "La superfície tancada comprovada és inferior a la superfície total útil",
	"Proportional_part_of_common_elements": "Part proporcional d'elements comuns",
	"Common_elements_cadastral_area": "Elements Comuns Cadastre",
	"Common_elements_registry_area": "Elements Comuns Registre",
	"Common_elements_checked_area": "Elements Comuns Comprovada",
	"Common_elements_adopted_area": "Elements Comuns Adoptada",
	"Total_areas_summary_table": "Resum de superfícies totals",
	"Register": "Registre",
	"Cadaster": "Cadastre",
	"Checked": "Comprovada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Ús",
	"Covered_outdoors_area": "Superfície espais coberts exteriors",
	"Uncovered_outdoors_area": "Superfície espais descoberts exteriors",
	"Built_plus_common_elements_area": "Superfície Construïda + Elem. Com.",
	"Built_plus_common_elements": "Construïda + Elem. Com.",
	"Common_elements": "Elements comuns",
	"Number_of_rooms_to_exterior": "Nº d'habitacions a exterior",
	"Day_night_zoning": "Zonificació dia / nit",
	"Door_opener": "Porter automàtic",
	"Fitted_cupboards": "Armaris encastats",
	"Gas": "Gas",
	"Sanitary_fittings": "Aparells sanitaris",
	"Taps": "Aixetes",
	"Hot_water": "Aigua calenta",
	"Fire_prevention": "Prevenció al foc",
	"Intrusion_prevention": "Prevenció a l'intrusió",
	"Foundation": "Fonamentació",
	"Roof": "Coberta",
	"External_enclosures": "Tancaments exteriors",
	"Insulation": "Aïllament",
	"External_carpentry": "Carpinteria exterior",
	"Glazing": "Envidrament",
	"Views": "Vistes",
	"Windows_size_and_quantity": "Dimensió i quantitat de finestres",
	"Noise_facade": "Nivell de soroll en façana",
	"Systems": "Instal·lacions",
	"conservation_status": "estat de conservació",
	"Building_shell": "Envolupant de l'edifici",
	"building_shell": "envolupant de l'edifici",
	"Shell": "Envolupant",
	"shell": "envolupant",
	"Interior_finishes": "Acabats interiors",
	"Living": "Estar",
	"Kitchen": "Cuina",
	"Walls": "Parets",
	"Ceilings": "Sostres",
	"Interior_carpentry": "Fusteria interior",
	"Circulations": "Circulacions",
	"BdE_files": "Fitxes BdE",
	"Construction_prices": "Costos de construcció",
	"Add_bec_property": "Afegir tipus d'immoble",
	"Add_bec_number": "Afegir nº B.E.C.",
	"Year": "Any",
	"Quarter": "Trimestre",
	"Bec_adjustment_coef": "Coeficient d'ajust del B.E.C.",
	"Adjusted_bec_price": "Preu ajustat del B.E.C.",
	"Expenses_and_industrial_benefit_bec_pct": "Percentatge de Despeses i Benefici Industrial.",
	"Construction_status": "Estat de construcció",
	"Construction_cost_notes": "Observacions sobre el cost de construcció",
	"Mandatary": "Mandatari",
	"Mandatary_entity": "Entitat mandatària",
	"Acc_mortgage_market_law_q": "Segueix la llei del mercat hipotecari?",
	"Acc_eco_decree_q": "Segueix la ordre ECO/805/2003?",
	"location": "localització",
	"Registry_property": "Finca registral",
	"Cadastral_file": "Fitxa Cadastral",
	"Nucleus_area": "Superfície del municipi",
	"Nucleus_type": "Tipus de nucli",
	"Locality": "Localitat",
	"Employment_occupation": "Ocupació laboral",
	"Population": "Població",
	"Population_density": "Densitat de població",
	"Population_growth": "Creixement de població",
	"Last_year": "Últim any",
	"Terrain_description": "Descripció del terreny",
	"Terrain_infrastructures": "Infraestructures del terreny",
	"Execution": "Execució",
	"Water_supply": "Subministrament d'aigua",
	"Terrain_area": "Superfície del terreny",
	"Site_quality": "Qualitat de l'emplaçament",
	"Underground_levels": "Nivells sota rasant",
	"Ground_level": "Nivell rasant",
	"Overground_levels": "Nivells sobre rasant",
	"Building_description": "Descripció de l'edificació",
	"Checkings_realized": "Comprovacions realitzades",
	"Documents_used": "Documentació utilitzada",
	"Interior_visit": "Visita interior de l'immoble",
	"Expropriation_procedure": "Procediment d'expropiació",
	"Expropriation_plan": "Pla o projecte d'expropriació",
	"Expropriation_admin_ruling": "Resolució administrativa expropiació",
	"Expropriation_file": "Expedient d'expropriació",
	"Occupancy": "Estat d'ocupació i ús",
	"Servitudes": "Servituds",
	"Public_protection_regime": "Règim de protecció pública",
	"Urban_paramaters_suitability": "Adequació al planejament urbanístic",
	"Another": "Una altra",
	"Approved_project_by_professional_association": "Projecte visat pel col·legi professional",
	"Cadastral_documents": "Documentació cadastral",
	"Construction_license": "Llicència de construcció",
	"Construction_last_certificate": "Últim certificat de construcció",
	"Construction_contract": "Contracte de construcció",
	"Occupancy_status": "Estat d'ocupació",
	"Photographic_report": "Reportatge fotogràfic",
	"Property_sketch": "Croquis de l'immoble",
	"Property_titles": "Document de propietat segons normativa",
	"Situation_plan": "Plànol de situació",
	"Ten_year_insurance": "Assegurança decennal",
	"Urban_plan": "Plànol urbanístic",
	"Habitability_conditions": "Condicions d'habitabilitat",
	"Main_orientation": "Orientació principal",
	"Property_title": "Títol de propietat",
	"Usage_assigned": "Ús assignat",
	"Usage_assigned_by_the_owner": "Ús assignat per la propietat",
	"Inspection_realized": "Comprovació realitzada",
	"Economical_activity": "Activitat econòmica",
	"Real_rights": "Drets reals",
	"Bulletin_number": "Nº de Butlletí",
	"a": "un",
	"Select": "Seleccionar",
	"Market_data": "Dades de mercat",
	"Market_samples": "Mostres de mercat",
	"Offer_date": "Data de l'oferta",
	"Sample": "Mostra",
	"Market_analysis": "Anàlisi de mercat",
	"Prices_estimated_yearly_evolution_pct": "Preus - evolució anual, variació estimada (%)",
	"Market_value_evolution_probability_pct": "Previsió evolució del valor de comparació (%)",
	"Offer_production": "Oferta - producció",
	"Offer_yearly_stock": "Oferta - Estoc anual",
	"Offer_trend": "Oferta - tendència",
	"Demand_level": "Demanda - nivell",
	"Demand_speed_of_sales": "Demanda - velocitat de vendes",
	"Demand_trend": "Demanda - tendència",
	"Prices_expectancy": "Preus - Expectativa",
	"Prices_past_cicles_volatility": "Expectativa - Volatilitat de cicles passats",
	"Market_conjuncture": "Conjuntura de mercat",
	"Market_value_reduction_probability_expectancy": "Expectativa - Probabilitat de reducció del valor de comparació",
	"Offer": "Oferta",
	"Demand": "Demanda",
	"Expectation": "Expectativa",
	"Prices": "Preus",
	"Maximum": "Màxim",
	"Minimum": "Mínim",
	"Mean": "Mitjana",
	"Median": "Mediana",
	"Market_prices": "Preus del mercat",
	"Neighbourhood": "Barri",
	"Situation": "Situació",
	"Samples": "Mostres",
	"Similarities": "Similituds",
	"Statistical_deviations": "Desviacions estadístiques",
	"Typical_deviation_of_the_sample": "Desviació típica de la mostra",
	"Technical_values_calculation": "Càlcul de valors tècnics",
	"Material_execution_cost_as_new": "Cost d'execució material a nou",
	"Finished_building_market_value": "Valor de mercat edifici acabat",
	"finished_building": "immoble acabat",
	"Total_values_calculation": "Càlcul de valors totals",
	"year": "any",
	"Other_values": "Altres valors",
	"Appraisal_value_determination_text": "D'acord amb els criteris establerts en l'ordre ECO 805/2003, el valor aplicable és:",
	"Add_constraint": "Afegir condicionant",
	"Add_warning": "Afegir advertiment",
	"Add_note": "Afegir observació",
	"Constraints": "Condicionants",
	"Constraints_foreseen_by_law": "Condicionants previstos per Llei",
	"Warnings_foreseen_by_law": "Advertiments previstos per Llei",
	"Notes_foreseen_by_barnatasa": "Observacions previstes per BARNA-TASA S.A.",
	"English": "Anglès",
	"Spanish": "Castellà",
	"The_Real_Estate_is_not_protected": "L'immoble no està protegit",
	"The_Real_Estate_is_not_rented_or_ceded": "L'immoble no està llogat o cedit",
	"There_is_no_cession_of_the_right_of_use": "El dret d'ús de l'immoble no està cedit",
	"The_value_is_not_calculated": "El valor no es calcula",
	"Elements_included_in_this_valuation": "Elements inclosos en aquesta valoració",
	"Market_value_adjustment_pct": "Percentatge d'ajust del valor de mercat",
	"Constraint": "Condicionant",
	"Warning": "Advertiment",
	"Note": "Observació",
	"Upload_photographs": "Carregar fotografies",
	"Photograph": "Fotografia",
	"Photographs": "Fotografies",
	"Image_footer": "Peu d'imatge",
	"Upload_files": "Carregar arxius",
	"File_name": "Nom de l'arxiu",
	"in": "en",
	"Registry_Documents": "Documents Registrals",
	"Cadastral_Documents": "Documents Cadastrals",
	"Urban_Planning_Documents": "Documents Urbanístics",
	"Plans": "Plànols",
	"Sketches": "Croquis",
	"Cession_Documents": "Documents de Cessió",
	"Contracts": "Contractes",
	"Other_Documents": "Altres Documents",
	"with_date": "amb data",
	"Date_of_issue": "Data d'emissió",
	"Signatures": "Signatures",
	"Report_date_of_issue": "Data d'emissió de l'informe",
	"Professional_that_visited_the_property": "Tècnic que va realitzar la visita",
	"Date_of_visit": "Data de la visita",
	"Appraisers": "Taxadors",
	"Supervisors": "Supervisors",
	"Appraisers_Index": "Índex de Taxadors",
	"Supervisors_Index": "Índex de Supervisors",
	"Add_appraiser": "Afegir taxador",
	"Add_supervisor": "Afegir supervisor",
	"Prof_assoc_reg_number": "Nº col·legiat",
	"Visit_date": "Data de la visita",
	"Technician_who_performed_the_visit": "Tècnic visita",
	"Visit": "Visita",
	"Floor_name": "Nom de planta",
	"Import_comparable_set": "Importar conjunt de comparables",
	"Import_comparable_set_from_another_market_study": "Importar conjunt de comparables d'un altre estudi de mercat",
	"There_are_unsaved_changes": "Hi ha canvis no desats",
	"Unsaved_data_will_be_lost": "Es perdran les dades no desades",
	"Cover": "Portada",
	"Annexed_documents": "Documents annexes",
	"Report_of": "Informe de",
	"correlated_pages_numbered_from": "pàgines correlatives, numerades de ",
	"technician": "tècnic",
	"Sanitary_fittings_quality": "Qualitat aparells sanitaris",
	"Taps_quality": "Qualitat aixetes",
	"Land_selected_area": "Mètode de selecció",
	"Urban_parameters_suitability": "Adequació al planejament urbanístic",
	"Maps": "Mapes",
	"Situation_maps": "Mapes de situació i emplaçament",
	"Other": "Altra",
	"Subsidy_status": "Qualificació de protecció pública",
	"Quote": "Pressupost",
	"Appraisal_quote": "Pressupost de taxació",
	"Appraisal_quotes": "Pressupostos de taxació",
	"Add_appraisal_quote": "Afegir pressupost de taxació",
	"Title_and_date_of_quote": "Títol i data del pressupost",
	"valuated_in_this_quote": "valorats en aquest pressupost",
	"Quote_title_missing_error_text": "Manca el títol del pressupost",
	"Print_quote_in_PDF": "Imprimir pressupost en PDF",
	"Create_new_real_estate": "Crear nou immoble",
	"Select_Real_estate_to_be_added": "Selecciona l'immoble a afegir",
	"Existing_Real_estates": "Immobles existents a la base de dades",
	"create_a_new_one": "crea'n un de nou",
	"staircase": "escala",
	"block": "bloc",
	"door": "porta",
	"Full_address": "Adreça completa",
	"Status": "Estat",
	"Quote_number": "Nº de pressupost",
	"Quote_content": "Contingut del pressupost",
	"Quote_title": "Títol del pressupost",
	"Travel_expenses": "Despeses de viatge",
	"Travel_one_way_hours": "Hores de viatge (anada)",
	"Travel_both_ways_hours": "Hores totals de viatge (anada i tornada)",
	"Travel_fees_per_hour": "Honoraris per hora de viatge",
	"Total_car_expenses_one_way": "Despeses de benzina i peatges (anada)",
	"Total_car_expenses_both_ways": "Despeses totals de benzina i peatges (anada i tornada)",
	"Total_travel_fees": "Despeses totals per desplaçament",
	"Quote_area_average_unit_price": "Mitjana de preus de la zona (€/m2)",
	"Quote_base_fees": "Honoraris base",
	"Quote_excess_pct": "% de l'excés dels honoraris base",
	"Quote_base_price": "Honoraris finals",
	"Quote_base_price_coef": "Coeficient d'ajust",
	"Valuation_quote": "Pressupost de taxació",
	"Appraisal_cost": "Cost de taxació",
	"Appraisal_fees": "Honoraris de taxació",
	"Appraisal_price": "Preu de taxació",
	"hours": "hores",
	"Area_prices": "Preus de la zona",
	"Area_average_unit_price": "Mitjana de preus de la zona",
	"Ads_date_range": "Franja de dates dels anuncis",
	"Current_area_prices": "Preus actuals de la zona",
	"pre_appraisal": "pre-taxació",
	"Pre_appraisal": "Pre-taxació",
	"Estimated_built_area": "Superfície construida estimada",
	"Pre_appraisal_value": "Valor de pre-taxació",
	"Area_average_price_coef": "Coeficient d'ajust del preu",
	"Adopted_area_average_price": "Preu unitari adoptat",
	"Car_fuel_expenses_one_way": "Cost de Benzina (anada)",
	"Car_fuel_expenses_both_ways": "Cost de Benzina (anada i tornada)",
	"Car_toll_expenses_one_way": "Cost dels Peatges (anada)",
	"Car_toll_expenses_both_ways": "Cost dels Peatges (anada i tornada)",
	"Valuation_pricing_info_table": "Taula de tarifes de taxació",
	"Check_prices": "Buscar preus",
	"Add_ad_manually": "Afegir nou anunci manualment",
	"Ads_index": "Índex d'anuncis",
	"Go_back_to_market_study": "Tornar a l'estudi de mercat",
	"Offer_price_reduction_coef": "Coeficient reductor del preu",
	"Cession_files": "Documents d'arrendament",
	"Lease": "Arrendament",
	"Gross_tax_per_1000_inhabitants": "Taxa bruta per cada 1.000 habitants",
	"Site": "Emplaçament",
	"Urban_planning": "Urbanisme",
	"Construction_description": "Descripció de la construcció",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Estat d'ocupació, règim de protecció, cessió, ús i drets reals",
	"Real_rights_protection_and_occupation": "Drets reals, protecció i ocupació",
	"PA_number": "Nº de col·legiat",
	"Quote_petitioner": "Sol·licitant del pressupost",
	"Quote_petitioners": "Sol·licitants de pressupost",
	"Dear": "Benvolgut",
	"Dear_m": "Benvolgut",
	"Dear_f": "Benvolguda",
	"Quote_sentence_01": "Ens plau adjuntar pressupost d'honoraris per a l'Informe de Taxació dels següents immobles",
	"with_purpose": "amb finalitat",
	"Approx_area": "Superfície aprox.",
	"Signed": "Signat",
	"Amount_money": "Import",
	"Total_cost_including_VAT": "Cost total (IVA inclòs)",
	"Fiscal_parameters": "Paràmetres fiscals",
	"VAT_pct": "IVA (%)",
	"Quote_sentence_02": "Es realitzarà pagament del 50% a l'inici del treball i el 50% restant a l'entrega dels Informes de Taxació",
	"Quote_sentence_03": "Abonar al compte bancari de BARNA-TASA, S.A.",
	"Quote_sentence_04": "Tasques a realitzar per a confecccionar els informes de taxació",
	"Quote_sentence_05": "Visita als immobles per un tècnic Arquitecte o Enginyer de BARNA-TASA",
	"Quote_sentence_06": "Elaboració de l'informe. Contingut",
	"Payment_details": "Detalls de pagament",
	"Required_documentation": "Documentació necessària",
	"Quote_sentence_07": "Entrega dels informes en format digital (PDF)",
	"Quote_sentence_08": "Si es requereix l'entrega en paper (opcional) s'aplicarà un cost addicional de 15 € en concepte d'impressió i enviament",
	"Quote_sentence_09": "Nom, NIF i adreça del sol·licitant",
	"Quote_sentence_10": "Nom, NIF i adreça fiscal per a la factura",
	"Quote_sentence_11": "Còpia completa de l'escriptura o de la nota registral",
	"Quote_sentence_12": "Còpia del IBI (dades Cadastrals) (opcional)",
	"Quote_sentence_13": "Còpia del contracte de lloguer i un rebut actualitzat si es tracta d'un immoble en lloguer",
	"Quote_sentence_14": "Finalitat de la taxació (adquisició o venta, constituir garanties hipotecàries, expropiació...)",
	"Quote_sentence_15": "Nom i telèfon de la persona de contacte per a visitar la finca",
	"Quote_sentence_16": "Plànols de la finca (opcional)",
	"At_your_disposal_for_any_clarification": "A la seva disposició per a qualsevol aclariment",
	"Kindest_regards": "Rebi les nostres cordials salutacions",
	"CFO_CHRO_female": "Directora de Finances i Recursos Humans",
	"Additional_costs": "Altres imports",
	"Quote_sentence_17": "En el cas de ser necessària l'assistència del tècnic als jutjats per ratificació de l'informe el cost serà de",
	"Quote_sentence_18": "L'entrega de  l'informe es farà en format digital (PDF). En cas de requerir-se l'entrega de l'informe en paper, el cost serà de 15 € en concepte d'impressió i enviament",
	"Appraisal_invoice": "Factura",
	"Appraisal_invoices": "Factures",
	"Add_appraisal_invoice": "Afegir factura",
	"Title_and_date_of_invoice": "Títol i data de factura",
	"valuated_in_this_invoice": "valorats en aquesta factura",
	"Invoice_title_missing_error_text": "Manca el títol de la factura",
	"Print_invoice_in_PDF": "Imprimir factura en PDF",
	"Valuation_invoice": "Factura",
	"Invoice": "Factura",
	"Client": "Client",
	"Invoice_number": "Nº de factura",
	"Invoice_content": "Contingut de la factura",
	"Invoice_title": "Títol de la factura",
	"Add_petitioner": "Afegir sol·licitant",
	"Create_new_contact": "Crear nou contacte",
	"No_petitioners_text": "No s'ha afegit cap contacte a la llista de sol·licitants. Selecciona un contacte i afegeix-lo a la llista fent click a 'afegir sol·licitant'",
	"No_records": "No hi ha registres",
	"Quotes_requested_by": "Pressupostos sol·licitats per",
	"Dear_sir_or_madam": "Benvolgut Sr. / Sra.",
	"Dear_sirs_or_madams": "Benvolguts Srs. / Sres.",
	"Dear_sir": "Benvolgut senyor",
	"Dear_madam": "Benvolguda senyora",
	"Dear_sirs": "Benvolguts senyors",
	"Dear_madams": "Benvolgudes senyores",
	"Dear_madams_and_sirs": "Benvolgudes senyores i senyors",
	"Dear_madam_and_sir": "Benvolguda senyora i senyor",
	"Dear_pl": "Benvolguts",
	"Dear_pl_f_m": "Benvolgudes i benvolguts",
	"Dear_pl_f": "Benvolgudes",
	"Dear_pl_m": "Benvolguts",
	"Main_email": "Adreça d'e-mail principal",
	"Add_other_email": "Afegir e-mail addicional",
	"Complete_name": "Nom complet",
	"Payment_conditions": "Condicions de pagament",
	"Note_w": "Nota",
	"Final_price": "Preu final",
	"Discount_pct": "Descompte (%)",
	"Discount_notes": "Observacions sobre el descompte",
	"Bank_name": "Nom del banc",
	"Court_assistance_fees": "Honoraris assistència judici",
	"Required_docs": "Documentació necessària",
	"Documentation_type": "Tipus de documentació",
	"Add_required_doc": "Afegir a la llista",
	"Document": "Document",
	"Petitioners_missing_error_text": "Falta indicar el sol·licitant de pressupost",
	"Realestates_missing_error_text": "Falta indicar els immobles del pressupost",
	"Requireddocs_missing_error_text": "Falta indicar la documentació necessària",
	"Discount": "Descompte",
	"Fees_incl_discount": "Honoraris amb descompte",
	"Quote_reference": "Pressupost associat a la factura",
	"Invoice_lines": "Línies de factura",
	"Add_invoice_line": "Afegir línia de factura",
	"Units": "Unitats",
	"Import_quote_concepts": "Importar conceptes del pressupost",
	"invoice": "factura",
	"line": "línia",
	"Lines_missing_error_text": "Falta introduir els conceptes de la factura",
	"Concept": "Concepte",
	"Add_client": "Afegir client",
	"Complete_fiscal_address": "Adreça fiscal completa",
	"Appraisal_invoice_description": "Descripció de la factura",
	"Invoice_to": "Factura a",
	"Emited_by": "Emesa per",
	"Invoice_Total": "Total Factura",
	"Emmission_date": "Data d'emissió",
	"Reference": "Referència",
	"Appraisal_invoices_index": "Índex de Factures",
	"Appraisal_quotes_index": "Índex de Pressupostos",
	"Invoice_fiscal_number": "Nº fiscal de factura",
	"Billing": "Facturació",
	"invoice_fiscal_number": "nº fiscal de factura",
	"Last_m": "Últim",
	"invoice_number": "nº de factura",
	"Last_created_invoice": "Última factura creada",
	"Welcome": "Benvingut",
	"Ad_description": "Descripció de l'anunci",
	"Upload_to_database": "Desar i incorporar a la base de dades",
	"Address_referral": "Adreça de referència",
	"Max_distance": "Distància màx.",
	"Print_report_s_certificate_in_PDF": "Imprimir informe/certificat en PDF",
	"Appraisal_certificate": "Certificat de taxació",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Arquitecte Superior, en qualitat de Director i Supervisor de Taxacions de BARNA-TASA, S.A., inscrita en el Registre Oficial de Societats de Taxació del Banco de España, amb el nº 4.470 i data d'inscripció 26 de Juny de 1.995,",
	"Certificate_text_02": "Que amb el número d'Expedient",
	"Certificate_text_03": "s'ha efectuat un informe de taxació amb data",
	"Certificate_text_04": "i la taxació consta en resum de les següents dades",
	"Certificate_text_05": "Per a que consti als efectes oportuns, firmo el present certificat a Barcelona, ",
	"certifies": "certifica",
	"Petitioner_TIN": "NIF del sol·licitant",
	"Petitioner_address": "Adreça del sol·licitant",
	"registered_in": "inscrita en",
	"from_the": "del",
	"Method_used_to_calculate_the_value": "Mètode utilitzat per calcular el valor adoptat",
	"Cost_value_current_state": "Valor del Cost a estat actual",
	"Comparison_value": "Valor de Comparació",
	"Maximum_legal_value": "Valor Màxim Legal",
	"Adjusted_market_value": "Valor de Mercat Ajustat",
	"Total_appraisal_value": "Valor total de taxació",
	"Real_estates_missing_error_text": "Manca afegir els immobles que conformen l'informe de taxació",
	"Sign_quote": "Signar pressupost",
	"Sign_appraisalreport": "Signar informe de taxació",
	"Appraiser_sign_appraisalreport": "Signar informe de taxació (Taxador)",
	"Supervisor_sign_appraisalreport": "Signar informe de taxació (Supervisor)",
	"Sign_invoice": "Signar factura",
	"Sign_certificate": "Signar certificat",
	"Signature": "Signatura",
	"Appraisers_signature": "Firma del Taxador",
	"Supervisors_signature": "Firma del Supervisor",
	"Main_telephonenumber": "Nº de telèfon principal",
	"Purpose": "Finalitat",
	"BEC_expenses_plus_builders_benefit_pct": "% de despeses i benefici del promotor en el preu del BEC",
	"pkg_number": "Nº de plaça",
	"Index": "Índex",
	"Cession_type": "Tipus de cessió",
	"Real_right_type": "Tipus de dret real",
	"Reports": "Informes",
	"Other_files": "Altres documents",
	"Construction_reposition_cost_as_new": "Cost de reposició de la construcció a nou",
	"Construction_value_in_actual_state": "Valor de la construcció a estat actual",
	"executed_construction": "construcció realitzada",
	"Integrity": "Integritat",
	"remaining": "restant",
	"or": "o",
	"Project": "Projecte",
	"Projects": "Projectes",
	"Add_project": "Afegir projecte",
	"Projects_of_the_Real_Estate": "Projectes",
	"BDE_files_index": "Índex de fitxes del BDE",
	"BDE_files": "Fitxes del BDE",
	"Asset_type": "Tipus d'actiu",
	"Property_usage": "Ús de l'immoble",
	"Parking_spots_included_number": "Nombre de places de pàrquing incloses",
	"BdE_appraisal_files": "Taxacions",
	"BdE_realestate_files": "Immobles",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relacions",
	"Insurance_value_rd_1982_text": "Valor de reemplaçament brut, exclòs el valor del terreny",
	"Insurance_value_rd_2009_text": "Valor de taxació, exclòs el valor del terreny",
	"VAT_not_included": "IVA no inclòs",
	"EEC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 125 €+ IVA",
	"OCC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 125 €+ IVA",
	"EECOCC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/ca.json
// module id = 2281
// module chunks = 0